<template>
  <div class="resource-category-edit-form">
    <el-form
      style="padding: 0;"
      label-position="top"
      label-width="100px"
    >
      <div class="row no-gutters card-box px-md-4">
        <div class="col-xs-12 col-md mr-md-3 d-flex justify-content-center justify-content-md-end">
          <div class="single-form ">
            <el-form-item label="회원권 명">
              <el-input
                v-model="form.name"
                placeholder="회원권 명을 입력해주세요."
              />
            </el-form-item>
            <el-form-item label="가격">
              <div class="el-input-group__unit">
                <el-input
                  v-model="price"
                  controls-position="right"
                  :min="0"
                  @input="priceChangeSubscriber"
                />
                <div class="input-unit">
                  원
                </div>
              </div>
            </el-form-item>
            <el-form-item>
              <div slot="label">
                {{ '최대 수강 ' + membershipSystem.long }}
                <span class="label-description">
                  유효 기간 내에 회원이 수강할 수 있는 {{ membershipSystem.long }}를 입력해주세요.
                </span>
              </div>
              <el-input-number-or-none
                key="1"
                v-model="form.balance"
                :unit="membershipSystem.short"
                :none-value="-1"
                :min="1"
              />
            </el-form-item>

            <el-form-item>
              <div slot="label">
                일일 최대 수강 횟수
                <span class="label-description">
                  하루에 회원이 최대로 수강할 수 있는 횟수를 입력하세요.
                </span>
              </div>
              <el-input-number-or-none
                key="2"
                v-model="form.daily_limit"
                unit="회/일"
                :none-value="-1"
                :max="100"
                :min="1"
              />
            </el-form-item>
          </div>
        </div>
        <div class="col-xs-12 col-md ml-md-3 d-flex justify-content-center justify-content-md-start">
          <div class="single-form">
            <el-form-item label="카테고리 (미선택시 기본 카테고리)">
              <el-select
                v-model="form.category"
                placeholder="카테고리를 선택해주세요."
                style="width: 100%;"
              >
                <el-option
                  v-for="category in parentMembershipCategories"
                  :key="category.id"
                  :label="category.name"
                  :value="category.id"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="유효 기간">
              <el-input-day v-model="form.duration" />
            </el-form-item>

            <el-form-item>
              <div slot="label">
                주간 최대 수강 횟수
                <span class="label-description">
                  일주일에 회원이 최대로 수강할 수 있는 횟수를 입력하세요.
                </span>
              </div>
              <el-input-number-or-none
                key="3"
                v-model="form.weekly_limit"
                :none-value="-1"
                :max="100"
                :min="1"
                unit="회/주"
              />
            </el-form-item>
          </div>
        </div>
      </div>
      <div class="d-md-flex justify-content-between mt-3 no-gutters">
        <div class="col" />
        <div
          v-show="form.id"
          class="col-12 col-md-6 px-5 px-md-0 form-bottom-description"
        >
          <strong>최대 수강 횟수</strong>‌를 수정할 경우 앞으로 새로 배정될 회원권의 기본 정보로 적용됩니다.<br>
          <strong>이 외 나머지 항목</strong> 수정 시에는 현재까지 배정된 모든 회원권에 바로 적용됩니다.
        </div>

        <div class="col d-flex justify-content-end align-items-end">
          <div>
            <el-button
              class="light-gray"
              @click="handleClickCancelForm"
            >
              취소
            </el-button>
            <el-loading-button
              class="black"
              :is-loading="isSavingForm"
              :disabled="!isFormValidated"
              @click="handleClickSaveForm"
            >
              저장
            </el-loading-button>
          </div>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import ElInputTime from '@/components/element-ui/ElInputTime';
import { TIME_UNIT, DAY_UNIT } from '@/constants';
import ElInputNumberOrNone from '@/components/element-ui/ElInputNumOrNone';
import ElInputDay from '@/components/element-ui/ElInputDay';
import { computedGetters } from '@/utils/vuex-helper';
import ElLoadingButton from '@/components/el-loading-button';
import { fiflboxApi } from '@/utils/api';
import { numberWithCommas, numberWithDeletedCommas } from '@/utils/etc';

export default {
  name: 'MembershipEditForm',
  components: { ElLoadingButton, ElInputDay, ElInputNumberOrNone, ElInputTime },
  props: ['data'],
  data() {
    return {
      form: {
        id: null,
        name: '',
        price: 100000,
        category: null,
        duration: DAY_UNIT.MONTH,
        balance: -1,
        daily_limit: -1,
        weekly_limit: -1
      },
      validationRules: {
        name: [{ required: true, message: ' ', trigger: 'blur' }]
      },
      isFormValid: {
        name: false
      },
      instructors: [],
      categories: [],
      isSavingForm: false,
      parentMembershipId: null,
      price: '100,000'
    };
  },
  async created() {
    if (this.$route.params.parentMembershipId) {
      this.parentMembershipId = this.$route.params.parentMembershipId;
      this.syncMembership();
    }
  },
  computed: {
    isFormValidated() {
      let formName = this.form.name && this.form.name !== '';

      return formName;
    },
    ...computedGetters(['membershipSystem', 'parentMembershipCategories'])
  },
  methods: {
    async handleClickSaveForm() {
      this.isSavingForm = true;

      if (!this.form.category) {
        this.form.category = this.parentMembershipCategories[0].id;
      }

      const { isSuccess, errorMessage } = this.form.id
        ? await this.updateMembership()
        : await this.createMembership();

      if (!isSuccess) {
        if (
          errorMessage !==
          '입력하신 이모지는 사용할 수 없습니다. 이모지를 제외하고 저장해 주시길 바랍니다.'
        ) {
          const content = this.form.id
            ? '회원권 수정에 실패하였습니다. 새로고침 후 다시 시도해주세요.'
            : '회원권 등록에 실패하였습니다. 새로고침 후 다시 시도해주세요.';

          this.$alert(content, '회원권 저장 실패');
        }
        this.isSavingForm = false;
        return;
      }

      this.$message(
        this.form.id ? '회원권이 수정됐습니다.' : '회원권이 등록됐습니다.'
      );
      this.$router.push('/setting/membership').catch(() => {});
    },
    async syncMembership() {
      let { data } = await fiflboxApi.v2.getParentMembershipsById(
        this.parentMembershipId
      );
      this.price = numberWithCommas(data.price);
      this.form = data;
    },
    async updateMembership() {
      try {
        let membershipId = this.form.id;
        let { data } = await fiflboxApi.v2.putParentMemberships(
          membershipId,
          this.form
        );

        return {
          isSuccess: true
        };
      } catch (err) {
        return {
          isSuccess: false,
          errorMessage: err
        };
      }
    },
    async createMembership() {
      try {
        await fiflboxApi.v2.postParentMemberships(this.form);

        return {
          isSuccess: true
        };
      } catch (err) {
        return {
          isSuccess: false,
          errorMessage: err
        };
      }
    },
    async handleClickCancelForm() {
      this.$router.push('/setting/membership').catch(() => {});
    },
    priceChangeSubscriber() {
      const newPrice = numberWithDeletedCommas(this.price);
      if (isNaN(newPrice)) {
        this.price = 0;
        this.form.price = 0;
      } else {
        this.price = numberWithCommas(newPrice);
        this.form.price = newPrice;
      }
    }
  }
};
</script>

<style lang="scss">
.form-bottom-description {
  font-size: 14px;
  line-height: 22px;
  color: #9b9b9b;
}

.resource-category-edit-form {
  .setting-cell {
    border-radius: 6px;
    background-color: #ffffff;
    box-shadow: 0 2px 4px 0 rgba(180, 180, 180, 0.5);
    padding: 20px;

    .header {
      height: 27px;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      letter-spacing: -0.6px;
      color: #4a4a4a;
      border-bottom: solid 1px #d3d3d3;
      margin-bottom: 8px;
    }
  }

  .course-controller {
    margin: 10px 20px;
  }

  .empty-message {
    min-height: 350px;

    & > div {
      text-align: center;

      .warning-message-container {
        margin-bottom: 30px;
      }
    }
  }
}
</style>
